<script context="module" lang="ts">
  import { writable, type Writable } from 'svelte/store';

  let isVisible = writable(false);
  let laterRedirect: Writable<string | null> = writable(null);

  export function openAvailabilityReminderModal() {
    isVisible.set(true);
  }

  export function openAvailabilityReminderAndRedirect(redirect: string) {
    laterRedirect.set(redirect);
    openAvailabilityReminderModal();
  }

  export function closeAvailabilityReminderModal() {
    isVisible.set(false);
  }
</script>

<script lang="ts">
  import { goto } from '$app/navigation';
  import { ConfirmDialog } from '$mds/Dialogs';

  const handleContinue = () => {
    if ($laterRedirect) {
      goto($laterRedirect);
    }
    closeAvailabilityReminderModal();
  };

  const handleConfirm = () => {
    goto('/account/studio/availability#slots');
  };
</script>

<ConfirmDialog
  bind:isOpen={$isVisible}
  scrollerClass=""
  title="You've created a session, now set your availability!"
  confirmButtonText="Set availability now"
  cancelButtonText="I’ll do it later"
  on:confirm={handleConfirm}
  on:cancel={handleContinue}
  on:closed={handleContinue}
>
  <p class="text-ondark-subtle text-center">
    To start receiving bookings at your preferred times, you'll need to set your availability. Go to Settings and select
    the days, times, and durations when you're available. You can update your availability anytime as needed.
  </p>
</ConfirmDialog>
